module.exports = __webpack_public_path__ + "static/media/Beach8.280c9c97.jpg";